import axios from "axios";
import env from "react-dotenv";

console.log(env.API_URL)
export default axios.create({
    //baseURL: "http://localhost:2020/SANPROD/",
    baseURL: env.API_URL,
    headers: {
        "Content-type": "application/json"
    }
});